import { Adapter, LoggingContext } from '../LlsLogger';
import { LogLevel } from '../LogLevels';

export class ConsoleAdapter implements Adapter {
  getName(): string {
    return 'console';
  }

  log(message: string, level: LogLevel, args?: LoggingContext) {
    let method;
    switch (level) {
      case 'debug':
        method = console.log;
        break;
      case 'info':
        method = console.info;
        break;
      case 'warn':
        method = console.warn;
        break;
      case 'error':
        method = console.error;
        break;
      case 'fatal':
        method = console.error;
        break;
      default:
        method = console.log;
    }

    /* tslint:disable no-console */
    method(`[${level.toUpperCase()}] ${message}`, args || null);
  }
}
